import React, { useEffect, useState } from "react";
import { Modal, Button, Checkbox, Input, message, Spin } from "antd";
import { SlidersOutlined } from "@ant-design/icons";
import BreadcrumbBanner from "../components/BreadcrumbBanner";
import { getRequest } from "../Auth/api";
import "./../style/menu.css";
import "./../style/common.css";
import SeoHelmet from "../Seo/SeoHelmet";
// import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import { useCart } from "../context/CartContext";
// import { postRequest } from "../Auth/api";

const { Search } = Input;


function Menu() {
  const [filterOpen, setFilterOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [cartModalOpen, setCartModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedChoices, setSelectedChoices] = useState([]);
  const [choiceOptions, setChoiceOptions] = useState([]);
  const [cartNote, setCartNote] = useState("");
  const [hasChoices, setHasChoices] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Category");
  // const [selectedCategories, setSelectedCategories] = useState([]);
  // const [selectedTags, setSelectedTags] = useState([]);

  // const navigate = useNavigate();
  // const UserId = localStorage.getItem("UserId");
const { setCartCount } = useCart();
console.log(setCartCount)
  useEffect(() => {
    fetchCategories();
    fetchTags();
    fetchItems();
  }, []);

  const { addToCart } = useCart();

  const fetchCategories = async () => {
    try {
      const res = await getRequest("category");
      setCategories(res.data || []);
    } catch {
      message.error("Failed to load categories");
    }
  };

  const fetchTags = async () => {
    try {
      const res = await getRequest("sub-category");
      const tagList =
        res.data?.map((tag) => ({
          label: tag.name,
          value: tag.description,
        })) || [];
      setTags(tagList);
    } catch {
      message.error("Failed to load subcategories");
    }
  };

  const fetchItems = async () => {
    try {
      const res = await getRequest("item");
      setItems(res.data?.data || []);
      setLoading(false);
    } catch {
      message.error("Failed to load items");
    }
  };

  const toggleFilter = () => setFilterOpen(!filterOpen);

  const handleCategoryChange = (cat) => {
    setSelectedCategories((prev) =>
      prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
    );
  };

  const handleTagChange = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };
  const clearAll = () => {
    setSelectedCategories([]);
    setSelectedTags([]);
  };
  const filteredItems = items.filter((product) => {
    const matchesCategory =
      selectedCategories.length === 0 ||
      selectedCategories.includes(product.category?.name);

    const matchesTags =
      selectedTags.length === 0 ||
      selectedTags.every((tag) =>
        product.description?.toLowerCase().includes(tag.toLowerCase())
      );

    const matchesSearch = product.name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

    return matchesCategory && matchesTags && matchesSearch;
  });

  const increment = (id) =>
    setCart((prev) => ({ ...prev, [id]: (prev[id] || 1) + 1 }));
  const decrement = (id) =>
    setCart((prev) => {
      const count = (prev[id] || 0) - 1;
      const newCart = { ...prev };
      if (count <= 0) delete newCart[id];
      else newCart[id] = count;
      return newCart;
    });

  // 3. Function to handle Add button click
  const handleAddToCartClick = async (item) => {
    // const token = localStorage.getItem("token");
    // if (!token) {
    //   message.warning("Please login to add items to cart");
    //   navigate("/login");
    //   return;
    // }
    setModalLoading(item.id);
    setSelectedItem(item);
    setSelectedChoices([]);
    setCartNote("");
    try {
      const res = await getRequest(`item-choice/by-item/${item.id}`);
      const choices = res.data || [];
      setChoiceOptions(choices);
      setHasChoices(choices.length > 0);
    } catch {
      setChoiceOptions([]);
      setHasChoices(false);
    } finally {
      setCartModalOpen(true);
      setModalLoading(null);
    }
  };

  // 4. Function to submit cart
const handleSubmitCart = async () => {
  const quantity = cart[selectedItem?.id] || 1;
  const selectedChoiceObjects = choiceOptions.filter((opt) =>
    selectedChoices.includes(opt.id)
  );

  addToCart(selectedItem, quantity, selectedChoiceObjects, cartNote);
  message.success("Item added to cart!");
  setCartModalOpen(false);
};

  return (
    <>
      <SeoHelmet page="menu" />
      <BreadcrumbBanner
        title="Menu"
        backgroundImage="/Images/banner-about.jpg"
      />

      <div className="menu-wrapper">
        <div className="menu-header">
          <Button className="custom-filter-btn" onClick={toggleFilter}>
            {selectedCategories.length + selectedTags.length > 0 && (
              <span className="filter-count">
                {selectedCategories.length + selectedTags.length}
              </span>
            )}
            Filter <SlidersOutlined style={{ marginLeft: 6 }} />
          </Button>

          <div className="tag-search">
            <div className="tags-display">
              <div className="tag-item">
                <img src="/Images/nog.png" alt="No Onion Garlic" loading="lazy"/>
                <span>No Onion Garlic</span>
              </div>
              <div className="tag-item">
                <img src="/Images/vegan.png" alt="Vegan" loading="lazy"/>
                <span>Vegan</span>
              </div>
              <div className="tag-item no-border">
                <img src="/Images/gf.png" alt="Gluten Free" loading="lazy"/>
                <span>Gluten Free</span>
              </div>
            </div>

            {/* 🔍 Mobile Search Icon */}
            <div
              className="mobile-search-toggle"
              onClick={() => setShowMobileSearch(!showMobileSearch)}
            >
              <img src="/Images/search.svg" alt="Search" loading="lazy"/>
            </div>

            {/* 🔍 Mobile Input - Show only when toggled */}
            {showMobileSearch && (
              <Search
                placeholder="Search Dish..."
                allowClear
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="menu-search mobile-visible"
                onBlur={() => setShowMobileSearch(false)} // hides input on blur
              />
            )}

            {/* 💻 Desktop Input - Always visible */}
            <div className="desktop-search">
              <Search
                placeholder="Search Dish..."
                allowClear
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="menu-search"
              />
            </div>
          </div>
        </div>

        <Spin spinning={loading} tip="Loading items..." className="loading">
          <div className="product-grid">
            {filteredItems.map((item) => (
              <div className="product-card" key={item?.id}>
                <div className="image-quantity">
                  <img
                    src={item?.image_url}
                    alt={item.name}
                    className="product-img"
                    loading="lazy"
                  />
                  <div className="quantity">
                    <button onClick={() => decrement(item.id)}>
                      <img src="./Images/minus.png" alt="-" loading="lazy"/>
                    </button>
                    <span>{cart[item.id] || 1}</span>
                    <button onClick={() => increment(item.id)}>
                      <img src="./Images/plus.png" alt="+" loading="lazy"/>
                    </button>
                  </div>
                </div>
                <div className="product-info">
                  <h4>{item?.name}</h4>
                  <p className="description-truncate">{item?.description}</p>
                  <div className="product-footer">
                    <div className="price">
                      {item?.less_price && <del>${item?.less_price}</del>}
                      <h3 className="main-price">${item?.price}</h3>
                    </div>
                    {/* <button
                      className="add-btn"
                      onClick={() => handleAddToCartClick(item)}
                    >
                      {modalLoading ? <Spin size="small" /> : "ADD"}
                    </button> */}

                    <button
                      className="add-btn"
                      onClick={() => handleAddToCartClick(item)}
                      disabled={modalLoading === item.id} // disable while loading
                    >
                      {modalLoading === item.id ? (
                        <Spin size="small" className="white-spinner" />
                      ) : (
                        "ADD"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Spin>

        <Modal
          title="Filter"
          open={filterOpen}
          footer={null}
          onCancel={toggleFilter}
          className="custom-filter-modal"
          // style={{ width: 700 }}
        >
          <div className="filter-modal-wrapper">
            {/* Sidebar Tabs */}
            <div className="filter-sidebar">
              <div
                className={`tab ${selectedTab === "Category" ? "active" : ""}`}
                onClick={() => setSelectedTab("Category")}
              >
                Category
              </div>
              <div
                className={`tab ${
                  selectedTab === "Customization" ? "active" : ""
                }`}
                onClick={() => setSelectedTab("Customization")}
              >
                Customization
              </div>
            </div>

            {/* Right Panel */}
            <div className="filter-options">
              {selectedTab === "Category" &&
                categories.map((cat) => (
                  <Checkbox
                    key={cat.name}
                    checked={selectedCategories.includes(cat.name)}
                    onChange={() => handleCategoryChange(cat.name)}
                  >
                    {cat.name}
                  </Checkbox>
                ))}

              {selectedTab === "Customization" &&
                tags.map((tag) => (
                  <Checkbox
                    key={tag.value}
                    checked={selectedTags.includes(tag.value)}
                    onChange={() => handleTagChange(tag.value)}
                  >
                    {tag.label}
                  </Checkbox>
                ))}
            </div>
          </div>

          {/* Footer */}
          <div className="filter-footer">
            <Button type="text" onClick={clearAll}>
              Clear Filter
            </Button>
            <Button type="primary" onClick={toggleFilter} className="fiter-btn">
              APPLY
            </Button>
          </div>
        </Modal>

        {/* // 6. Add Modal at the end of return JSX */}
        <Modal
          title={selectedItem?.name || "Add to Cart"}
          open={cartModalOpen}
          onCancel={() => setCartModalOpen(false)}
          footer={null}
           style={{ width: 600 }}
        >
          {selectedItem && (
            <div className="add-cart-modal">
              <div className="add-cart-image">
                <img
                  src={selectedItem.image_url}
                  alt={selectedItem.name}
                  style={{ marginBottom: 10 }}
                  loading="lazy"
                />
              </div>
              <p>{selectedItem.description}</p>
              <div style={{ marginBottom: 10 }}>
                <strong>Quantity:</strong> {cart[selectedItem.id] || 1}
              </div>

              {hasChoices && (
                <div>
                  <h4>Select Choices</h4>
                  {choiceOptions.map((choice, index) => (
                    <div key={choice.id} className="choice-item">
                      <Checkbox
                        checked={selectedChoices.includes(choice.id)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setSelectedChoices((prev) =>
                            checked
                              ? [...prev, choice.id]
                              : prev.filter((id) => id !== choice.id)
                          );
                        }}
                      >
                        {choice.name} (+${choice.price})
                      </Checkbox>
                      {index !== choiceOptions.length - 1 && (
                        <div className="divider-line" />
                      )}
                    </div>
                  ))}
                </div>
              )}

              <div style={{ marginTop: 15 }}>
                <h4>Note</h4>
                <Input.TextArea
                  placeholder="Any special instructions..."
                  value={cartNote}
                  onChange={(e) => setCartNote(e.target.value)}
                  rows={3}
                />
              </div>

              <div className="add-to-order-bar">
                <button className="order-submit-btn" onClick={handleSubmitCart}>
                  <FaPlus />  Add to Cart
                  <span className="order-price">
                    $
                    {(
                      (parseFloat(selectedItem.price) +
                        choiceOptions
                          .filter((opt) => selectedChoices.includes(opt.id))
                          .reduce((sum, c) => sum + parseFloat(c.price), 0)) *
                      (cart[selectedItem.id] || 1)
                    ).toFixed(2)}
                  </span>
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
}

export default Menu;
